import { appInfo } from "../../network/service"
import { fetchApiData } from "../../utils/utils"

export const getMenuItems=async (appInfo)=>{
  const api='menu/items'
  return await fetchApiData(appInfo,api)
}

